/* eslint-disable prettier/prettier */
export const section = [
  'w-full flex flex-col items-center',
  'gap-[3.25rem] px-4 pt-[4rem] pb-5 max-w-[23.438rem]',
  'md:max-w-[70rem] md:flex-row md:justify-between md:gap-0 md:px-0 md:pt-[7.5rem] md:pb-[5rem]'
].join(' ');

export const imageWrap = [
  'relative',
  'w-[21.438rem] h-[13.313rem] rounded-[1.25rem] overflow-hidden',
  'md:w-[33.125rem] md:h-[20.625rem] md:rounded-[1.5rem]'
].join(' ');

export const image = 'object-contain';

export const overlay = ['absolute top-[6.5rem] left-[10.375rem]', 'md:left-[16.063rem] md:top-[10.563rem]'].join(' ');

export const typeIt = '[--ti-cursor-color:#3D43FC]';

export const text = [
  'font-semibold',
  'text-[0.75rem] leading-[0.875rem] tracking-[-0.05rem ]',
  'md:text-[1.125rem] md:leading-[0.875rem] md:tracking-[-0.05rem] md:text-[#1F2937]'
].join(' ');
